import type { JournalData, MeasureRecord } from "@qendo/profile/journal";
import type { MeasureData, TrackableData } from "@qendo/trackables";
import type { ReactNode } from "react";
import { Text } from "react-native";
import { Only } from "~/components/permission/Only";
import { QendoIcon } from "~/components/QendoIcon";
import type { OptionFinder } from "~/providers/OptionsProvider";

export function makeMeasureRecord(measures?: MeasureData[] | null): MeasureRecord {
    return Object.fromEntries((measures ?? []).map((r) => [r.type, null]));
}

type BaseMeasureListing = {
    title: string;
    key: string;
};
export type FilledMeasureListing = {
    value: ReactNode;
} & BaseMeasureListing;
export type EmptyMeasureListing = {
    value: null;
} & BaseMeasureListing;
export type MeasureListing = FilledMeasureListing | EmptyMeasureListing;

export function extractMeasures(
    findOption: OptionFinder,
    trackable?: TrackableData | null,
    journal?: JournalData | null,
    unfiltered?: boolean,
): MeasureListing[] {
    return trackable?.measures && journal?.measures
        ? trackable.measures
              .map(({ title, type }) => {
                  const selected = (journal.measures as MeasureRecord)[type] ?? null;
                  const option = (selected && findOption(type, selected)) || null;

                  return {
                      title,
                      value: option ? (
                          <>
                              <Only when={option.colour}>
                                  <QendoIcon name="circle-lg-filled" color={option.colour} style={{ marginRight: 4 }} />
                              </Only>
                              <Text>{option.title}</Text>
                          </>
                      ) : null,
                      key: `${journal.id}_${type}_${selected ?? "never"}`,
                  };
              })
              .filter(({ value }) => unfiltered || value !== null)
        : [];
}
